module.exports = __webpack_public_path__ + "img/kjdlq.0f114075.png";